<template>
  <section id="experience">
    <div id="notify" :class="notifyclass">
      <div class="notify-details">
        <div>{{ notifymessage }}</div>
        <v-btn @click="closeNotify()">Zavřít</v-btn>
      </div>
    </div>

    <div class="experience-details">
      <h2>Datum {{ termdate }} | Střelnice {{ termrange }}</h2>
      <h3>Volných míst: {{ termspots }}</h3>

      <v-form class="form" action="" method="post" ref="form" lazy-validation>
        <v-text-field
          label="Jmeno *"
          id="name"
          name="firstName"
          :rules="rules_name"
          required
        ></v-text-field>
        <v-text-field
          label="Přijmení *"
          id="lastName"
          name="lastName"
          :rules="rules_surname"
          required
        ></v-text-field>
        <v-text-field
          label="Email *"
          id="email"
          name="emailAddress"
          :rules="rules_email"
          required
        ></v-text-field>
        <v-text-field
          label="Telefon *"
          id="phone"
          name="phoneNumber"
          :rules="rules_phone"
          required
        ></v-text-field>
        <v-text-field
          label="Ulice *"
          id="street"
          name="addressStreet"
          :rules="rules_street"
          required
        ></v-text-field>
        <v-text-field
          label="Město *"
          id="city"
          name="addressCity"
          :rules="rules_city"
          required
        ></v-text-field>
        <v-text-field
          label="PSČ *"
          id="zip"
          name="addressPostalCode"
          :rules="rules_zip"
          required
        ></v-text-field>
        <v-checkbox v-model="checked" :rules="[v => !!v || 'Musíte být starší 18 let']" label="Jsem starší 18 let" id="ageCheck" required></v-checkbox>
        <v-checkbox v-model="idChecked" :rules="[v => !!v || 'Pro dokončení rezervace je nutné potvrdit platný osobní doklad']" label="Potvrzuji, že všechny osoby jsou občany ČR nebo cizinci s platným pobytem na území ČR a jsou držiteli platného dokladu totožnosti (cestovní pas nebo občanský průkaz) vydaného Českou republikou, případně držiteli Evropského zbrojního pasu" id="idCheck" required></v-checkbox>
        <v-text-field
          label="Čislo voucheru *"
          id="voucher_code"
          name="voucherCode"
          :rules="rules_voucher"
          :value="voucher_code"
          required
        ></v-text-field>

        <v-btn @click="post_term">Poslat</v-btn>
      </v-form>
      <GoBack />
    </div>
  </section>
</template>
<script>
import GoBack from "@/components/GoBack";
import axios from "axios";
import funcs from "@/ranges.js";

export default {
  components: {
    GoBack
  },
  props: {
    slug: {
      type: String,
      required: true
    },
    experienceSlug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      termdate: "",
      notifyclass: "hidden",
      notifymessage: "",
      termrange: "",
      termspots: "",
      voucher_code: "",
      current: {},
      ranges: [],
      route: "",
      range: {},
      img: "",
      terms: [],
      term: {},
      formated_terms: {},
      prefixes: {},
      checked: false,
      idChecked: false,

      rules_street: [v => !!v || "Ulice je povinná"],
      rules_city: [v => !!v || "Město je povinné"],
      rules_zip: [
        v => !!v || "PSČ je povinné",
        v => /^[0-9 ]+$/.test(v) || "PSČ může obsahovat pouze čísla"
      ],
      rules_name: [
        v => !!v || "Jméno je povinné",
        v =>
          /^[a-zA-Zá-žÁ-Ž ]+$/.test(v) || "Jméno může obsahovat pouze písmena"
      ],
      rules_surname: [
        v => !!v || "Přijmení je povinné",
        v =>
          /^[a-zA-Zá-žÁ-Ž ]+$/.test(v) ||
          "Přijmení může obsahovat pouze písmena"
      ],
      rules_date: [v => !!v || "Datum narození je povinné"],

      rules_email: [
        v => !!v || "Email je povinný",
        v =>
          (v &&
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            )) ||
          "Email není ve správném tvaru"
      ],
      rules_phone: [
        v => !!v || "Telefon je povinný",
        v =>
          (v && /^(\+[0-9]{0,3})?\s?\d{3}\s?\d{3}\s?\d{3}$/.test(v)) ||
          "Telefon není ve správném tvaru"
      ],
      rules_voucher: [
        v => !!v || "Číslo voucheru je povinné",
        v =>
          (v && !/^[a-zA-Z0-9]{8}$/.test(v)) ||
          "Vložili jste kód pro sdílení namísto reálneho kódu voucheru. Správny kód voucheru je ve tvaru XXX-YYYYY - například QAD-COSI9"
      ],
      menu: false,
      date: "",
      activePicker: null
    };
  },
  mounted() {
    this.id = this.experienceSlug;
    this.setValues(); // set values from current term
    this.render(); // render terms
  },

  methods: {
    closeNotify() {
      this.notifyclass = "hidden";
      if (this.route == "home") {
        this.route = "";
        this.$router.push({ name: "home" });
      }
    },

    post_term() {
      this.$refs.form.validate();
      let formData = $(".form").serialize();

      let voucher_code = $("#voucher_code").val();

      if (!/^[a-zA-Z0-9-]+$/.test(voucher_code)) {
        this.notifyclass = "";
        this.notifymessage = "Zadali jste neplatný kód voucheru";
        return;
      }

      if(!this.checked){
        this.notifyclass = "";
        this.notifymessage = "Musíte potvrdit, že jste starší 18 let";
        return;
      }
      if(!this.idChecked){
        this.notifyclass = "";
        this.notifymessage = "Pro dokončení rezervace je nutné potvrdit platný osobní doklad";
        return;
      }
      formData += "&ageCheck=" + this.checked;
      formData += "&idCheck=" + this.idChecked;

      let url =
        "https://strelnice.autocrm.cz/?entryPoint=Reservation&eventId=" +
        this.experienceSlug +
        "&" +
        formData;

      axios
        .get(url)
        .then(response => {
          const data = response.data;
          this.notifyclass = "";
          this.route = "home";
          this.notifymessage = `Vaše rezervace voucheru ${voucher_code} na střelnici ${data.shootingRange} ve dne ${data.eventDate} v
 čase ${data.event} byla úspěšně odeslána.`;
        })
        .catch(error => {
          let rescode = error.response.status;
          let resbody = error.response.data.message || "";

          this.notifyclass = "";

          if (resbody != "") {
            this.notifymessage = resbody;
          } else {
            this.notifymessage = this.errorMessage(rescode);
          }
        });
    },


    errorMessage(error_code) {
      switch (error_code) {
        case 400:
          return "K vytvoření rezervace je nutné vyplnit všechny povinné pole.";
        default:
          return "Vaši rezervaci se nezdařilo vytvořit zkuste to znovu později";
      }
    },


    save(date) {
      this.$refs.menu.save(date);
    },

    render() {
      if (this.$root.loading != true) {
        let find = this.terms.find(function(element) {
          return element.eventId == this.id;
        }, this);
        this.term = find;

        let date_s = this.term.dateStart + ".000Z";
        date_s = date_s.replace(/ /g, "T");
        let date = funcs.convertToCzech(new Date(date_s));
        let hour = funcs.padToDigits(date.getHours());
        let minute = funcs.padToDigits(date.getMinutes());
        let second = funcs.padToDigits(date.getSeconds());
        let formattedDate = hour + ":" + minute + ":" + second;

        this.termdate = formattedDate;

        this.termrange = this.term.range_name;
        this.termspots = this.term.spots;
        if (this.$root.voucher) {
          this.voucher_code = this.$root.voucher;
        }
      }
    },
    setValues() {
      if (this.$root.loading != true) {
        this.ranges = this.$root.ranges;
        this.terms = this.$root.terms;
        this.prefixes = this.$root.prefixes;
        this.formated_terms = this.$root.formated_terms;
        this.markers = this.$root.markers;
        this.calendarTerms = this.$root.calendarTerms;
        this.activeDates = this.$root.activeDates;
      }
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    "$root.loading": function(val) {
      if (val == false) {
        this.setValues();
        this.render();
      }
    }
  }
};
</script>

<style scoped>
.v-card > .v-card__progress + :not(.v-btn):not(.v-chip):not(.v-avatar),
.v-card > :first-child:not(.v-btn):not(.v-chip):not(.v-avatar) {
  display: none !important;
}

#experience {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  border: 0px;
  overflow: hidden;
  z-index: 999999;
  background: #dddd;
  overflow: auto;
}

.experience-details {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);

  position: absolute;
  top: 2%;
  background-color: white;
  left: 0;
  right: 0;
  width: 50%;
  margin-left: auto;
  margin-right: auto;

  padding: 25px;
  border-radius: 20px;
}

@media (max-width: 992px) {
  .experience-details {
    width: 100%;
  }
}

#notify {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  border: 0px;
  overflow: hidden;
  z-index: 999999;
  background: #dddd;
}

.notify-details {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 20%;
  background-color: white;
  left: 0;
  right: 0;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  padding: 25px;
  border-radius: 20px;
}

img {
  max-width: 600px;
  height: auto;
  width: 100%;
  max-height: 400px;
}

p {
  margin: 0 40px;
  font-size: 20px;
  text-align: left;
}

.go-back {
  position: absolute;
  top: 0px;
  left: 0px;

  border-radius: 20px 0px 20px 0px;

  display: flex;
  cursor: pointer;
  padding: 10px;
  background-color: black;
  width: fit-content;
}

.go-back:hover {
  background-color: gray;
}
</style>
<style>
#birth_date {
  border: none;
}

.error--text {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}
</style>
